class RewardProgressBar extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  static get observedAttributes() {
    return ['total', 'tiers', 'has-paddle'];
  }

  attributeChangedCallback() {
    this.render();
  }

  getTierIcon(icon) {
    if (icon === "free-shipping") {
      return `<svg viewBox="0 0 20 20">
        <path fill-rule="evenodd" d="M4 5.25a.75.75 0 0 1 .75-.75h6.991a2.75 2.75 0 0 1 2.645 1.995l.427 1.494a.25.25 0 0 0 .18.173l1.681.421a1.75 1.75 0 0 1 1.326 1.698v1.219a1.75 1.75 0 0 1-1.032 1.597 2.5 2.5 0 1 1-4.955.153h-3.025a2.5 2.5 0 1 1-4.78-.75h-.458a.75.75 0 0 1 0-1.5h2.5c.03 0 .06.002.088.005a2.493 2.493 0 0 1 1.947.745h4.43a2.493 2.493 0 0 1 1.785-.75c.698 0 1.33.286 1.783.748a.25.25 0 0 0 .217-.248v-1.22a.25.25 0 0 0-.19-.242l-1.682-.42a1.75 1.75 0 0 1-1.258-1.217l-.427-1.494a1.25 1.25 0 0 0-1.202-.907h-6.991a.75.75 0 0 1-.75-.75Zm2.5 9.25a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm8 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"></path>
        <path d="M3.25 8a.75.75 0 0 0 0 1.5h5a.75.75 0 0 0 0-1.5h-5Z"></path>
      </svg>`;
    }

    if (icon === "free-gift") {
      return `<svg viewBox="0 0 20 20"><path fill-rule="evenodd" d="M8.798 7.992c-.343-.756-1.098-1.242-1.928-1.242-1.173 0-2.119.954-2.119 2.122 0 1.171.95 2.128 2.125 2.128h.858c-.595.51-1.256.924-1.84 1.008-.41.058-.694.438-.635.848.058.41.438.695.848.636 1.11-.158 2.128-.919 2.803-1.53.121-.11.235-.217.341-.322.106.105.22.213.34.322.676.611 1.693 1.372 2.804 1.53.41.059.79-.226.848-.636.059-.41-.226-.79-.636-.848-.583-.084-1.244-.498-1.839-1.008h.858c1.176 0 2.125-.957 2.125-2.128 0-1.168-.946-2.122-2.119-2.122-.83 0-1.585.486-1.928 1.242l-.453.996-.453-.996Zm-.962 1.508h-.96c-.343 0-.625-.28-.625-.628 0-.344.28-.622.619-.622.242 0 .462.142.563.363l.403.887Zm3.79 0h-.96l.403-.887c.1-.221.32-.363.563-.363.34 0 .619.278.619.622 0 .347-.282.628-.625.628Z"></path><path fill-rule="evenodd" d="M2.499 6.75c0-1.519 1.231-2.75 2.75-2.75h9.5c1.519 0 2.75 1.231 2.75 2.75v2.945l.002.055c0 .018 0 .037-.002.055v3.445c0 1.519-1.231 2.75-2.75 2.75h-9.5c-1.519 0-2.75-1.231-2.75-2.75v-6.5Zm13.5 2.25h-1.248c-.414 0-.75.336-.75.75s.336.75.75.75h1.248v2.75c0 .69-.56 1.25-1.25 1.25h-4.748v-1c0-.414-.336-.75-.75-.75s-.75.336-.75.75v1h-3.252c-.69 0-1.25-.56-1.25-1.25v-2.792c.292-.102.502-.38.502-.708 0-.327-.21-.606-.502-.708v-2.292c0-.69.56-1.25 1.25-1.25h3.252v.75c0 .414.336.75.75.75s.75-.336.75-.75v-.75h4.748c.69 0 1.25.56 1.25 1.25v2.25Z"></path></svg>`;
    }

    return "";
  }

  render() {
    const globalTotal = parseFloat(this.getAttribute('total')) || 0;
    const tiers = JSON.parse(this.getAttribute('tiers') || '[]');
    const hasSup = this.getAttribute('has-paddle') || false;
    
    // Ensure maxThreshold is properly calculated
    const maxThreshold = (tiers.length > 0 && parseFloat(tiers[tiers.length - 1].threshold) > 0) ? parseFloat(tiers[tiers.length - 1].threshold) : 100;

    // 1. Determine which tiers are fully unlocked
    const unlockedTiers = tiers.filter(t => {
      const currentVal = t.current !== undefined ? parseFloat(t.current) : globalTotal;
      return currentVal >= parseFloat(t.threshold);
    });

    // Find the NEXT tier to unlock
    const nextTier = tiers.find(t => {
      const currentVal = t.current !== undefined ? parseFloat(t.current) : globalTotal;
      return currentVal < parseFloat(t.threshold);
    });

    // 2. Build the dynamic message
    let message = "";
    

    if (nextTier) {
      const currentVal = nextTier.current !== undefined ? parseFloat(nextTier.current) : globalTotal;
      // Calculate amount needed and use Number() to drop trailing zeros (e.g. 10.00 becomes 10)
      const amountNeeded = Number((parseFloat(nextTier.threshold) - currentVal).toFixed(2));
      
      // Check for specific labels to inject "a" where it sounds natural
      const labelText = nextTier.label.toLowerCase();
      const article = labelText.includes('bag') || labelText.includes('gift') ? 'a ' : '';
      
      message = `You're £${amountNeeded} away from ${article}${labelText}!`;
      const isRestricted = nextTier?.label == "Free Tote Bag";
      if (isRestricted) {
        message += `<div class="info-wrapper">
              <svg class="info-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <circle cx="12" cy="12" r="10"></circle>
                <line x1="12" y1="16" x2="12" y2="12"></line>
                <line x1="12" y1="8" x2="12.01" y2="8"></line>
              </svg>
              <div class="tooltip">Paddle boards are not included in the free tote bag threshold.</div>
            </div>`;
      }
    } else if (unlockedTiers.length > 0) {
      const names = unlockedTiers.map(t => t.label.toLowerCase());
      message = `You've unlocked ${names.join(' and ')}!`;
    } else {
      message = "Add more to unlock rewards!";
    }
    

    // 3. Smart Progress Bar Calculation
    let progressPercentage = 0;
    let previousPosition = 0;

    for (let i = 0; i < tiers.length; i++) {
      const tier = tiers[i];
      const currentVal = tier.current !== undefined ? parseFloat(tier.current) : globalTotal;
      const threshold = parseFloat(tier.threshold);
      const position = (threshold / maxThreshold) * 100;

      if (currentVal >= threshold) {
        progressPercentage = position;
        previousPosition = position;
      } else {
        const calculatedPos = (currentVal / maxThreshold) * 100;
        progressPercentage = Math.max(previousPosition, calculatedPos);
        break; 
      }
    }

    // Prevent overflow
    progressPercentage = Math.min(progressPercentage, 100);

    this.shadowRoot.innerHTML = `
      <style>

      .info-wrapper { position: relative; display: inline-flex; cursor: pointer; align-items: center; }
        .info-icon { width: 20px; height: 20px; color: #666; vertical-align: middle; }
        
        .tooltip {
          position: absolute; 
          // bottom: 150%; 
          left: 50%; 
          transform: translateX(-50%);
          background: #000; 
          color: #fff; 
          padding: 10px 14px; 
          border-radius: 2px;
          font-size: 12px; 
          width: 200px; 
          visibility: hidden; 
          opacity: 0;
          transition: opacity 0.2s; 
          z-index: 20; 
          pointer-events: none;
          line-height: 1.4; 
          font-weight: 400;
        }
        .tooltip::after {
          content: ""; 
          position: absolute; 
          top: 100%; 
          left: 50%; 
          margin-left: -6px; 
          border-width: 6px; 
          border-style: solid;
          border-color: #000 transparent transparent transparent;
        }
        .info-wrapper:hover .tooltip { 
          visibility: visible; 
          opacity: 1; 
        }



        :host {
          display: block;
          font-family: sans-serif;
          margin: 20px 0;
          --bar-height: 8px;
          --marker-size: 30px;
          --active-color: #000;
          --inactive-color: #e0e0e0;
        }
        .container {
          width: 100%;
          max-width: 600px;
          margin: 0 auto;
          text-align: center;
        }
        .message {
          font-size: 15px;
          margin-bottom: 0.5rem;
          color: #000;
          font-family: 'Montserrat';
          width: 100%;
          display: flex;
          justify-content: center;
          gap: 5px;
        }
        .progress-wrapper {
          position: relative;
          height: var(--marker-size);
          display: flex;
          align-items: center;
          margin-bottom: 30px;
        }
        .track-bg {
          position: absolute;
          width: 100%;
          height: var(--bar-height);
          background: var(--inactive-color);
          border-radius: 4px;
          z-index: 1;
        }
        .track-fill {
          position: absolute;
          height: var(--bar-height);
          background: var(--active-color);
          border-radius: 4px;
          z-index: 2;
          transition: width 0.5s ease-out;
        }
        .markers {
          position: absolute;
          width: 100%;
          height: 100%;
          z-index: 3;
        }
        .marker {
          position: absolute;
          top: 50%;
          transform: translate(-50%, -50%);
          display: flex;
          flex-direction: column;
          align-items: center;
        }
        .icon-circle {
          width: var(--marker-size);
          height: var(--marker-size);
          background: var(--inactive-color);
          color: white;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: background 0.3s ease;
          font-size: 20px;
          border: 1px solid #000;
        }
        .icon-circle svg {
            width: 60%;
            height: auto;
        }
        .marker.unlocked .icon-circle {
          background: var(--active-color);
          color: #fff;
          fill: #fff;
        }
        .label {
          position: absolute;
          bottom: calc(0px - 18px);
          white-space: nowrap;
          font-size: 10px;
          color: #000;
          font-family: 'Montserrat';
        }
      </style>
     
      <div class="container">
        <div class="message">${message}</div>
        <div class="progress-wrapper">
          <div class="track-bg"></div>
          <div class="track-fill" style="width: ${progressPercentage}%"></div>
          <div class="markers">
            ${tiers.map(tier => {
              const currentVal = tier.current !== undefined ? parseFloat(tier.current) : globalTotal;
              const threshold = parseFloat(tier.threshold);
              const isUnlocked = currentVal >= threshold;
              const position = (threshold / maxThreshold) * 100;              
              const iconHTML = this.getTierIcon(tier.icon);
              return `
                <div class="marker ${isUnlocked ? 'unlocked' : ''}" style="left: ${position}%">
                  <div class="icon-circle">${iconHTML}</div>
                  <span class="label">${tier.label}</span>
                </div>
              `;
            }).join('')}
          </div>
        </div>
      </div>
    `;
  }
}

customElements.define('reward-progress-bar', RewardProgressBar);


class RecommendationSlider extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
    this.products = [];
    this.currentIndex = 0;
  }

  static get observedAttributes() {
    return ['product-ids', 'limit', 'intent'];
  }

  async connectedCallback() {
    await this.fetchRecommendations();
  }

  async fetchRecommendations() {
    const ids = (this.getAttribute('product-ids') || '').split(',').filter(id => id.trim());
    const limit = this.getAttribute('limit') || 4;
    const intent = this.getAttribute('intent') || 'complementary';

    if (!ids.length) return;

    try {
      const requests = ids.map(id => 
        fetch(`/recommendations/products.json?product_id=${id.trim()}&limit=${limit}&intent=${intent}`)
          .then(res => res.json())
      );

      const results = await Promise.all(requests);
      const allProducts = results.flatMap(data => data.products || []);
      // Deduplicate
      this.products = Array.from(new Map(allProducts.map(p => [p.id, p])).values());
      
      this.render();
    } catch (err) {
      console.error("Failed to load recommendations:", err);
    }
  }

  scrollSlider(direction) {
    const slider = this.shadowRoot.querySelector('.slider-track');
    const items = this.shadowRoot.querySelectorAll('.product-card');
    
    // Update index with looping logic
    this.currentIndex += direction;

    if (this.currentIndex >= items.length) {
      this.currentIndex = 0; // Loop to start
    } else if (this.currentIndex < 0) {
      this.currentIndex = items.length - 1; // Loop to end
    }

    const scrollAmount = items[this.currentIndex].offsetLeft;
    slider.scrollTo({ left: scrollAmount, behavior: 'smooth' });
  }

  async addToCart(variantId) {
    const btn = this.shadowRoot.querySelector(`[data-id="${variantId}"]`);
    const originalText = btn.innerText;
    btn.innerText = "Adding...";
    
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      });
      btn.innerText = "Added!";
      new theme.CartDrawer();
    } catch (e) {
      btn.innerText = "Error";
    }

    setTimeout(() => btn.innerText = originalText, 2000);
  }

  render() {
    if (!this.products.length) return;
    console.log(this.products)

    this.shadowRoot.innerHTML = `
      <style>
        :host { 
          display: block; 
          font-family: 'sans-serif;
          margin: 40px 0;
        }
        
        .container-bg {
            width: calc(100% - 1rem);
            margin: 0px auto;
        }
        .section-title {
          text-align: center;
          font-size: 15px;
          font-weight: 600;
          margin-bottom: 10px;
          color: #000;
        }

        .wrapper { 
          position: relative; 
          max-width: 600px; 
          margin: 0 auto; 
          padding: 0; 
          margin-bottom: 20px;
        }
        
        .slider-track {
          display: flex;
          overflow-x: hidden; /* Hide scrollbar for clean loop */
          scroll-snap-type: x mandatory;
          scroll-behavior: smooth;
          gap: 0;
        }

        .product-card {
          flex: 0 0 100%;
          scroll-snap-align: start;
          display: grid;
          grid-template-columns: 90px minmax(0, 1fr); /* important */
          gap: 1rem;
          align-items: center;
          width: 100%;
          box-sizing: border-box;          
          background: #f8f8f8;
          padding: 0.5rem 1rem;
        }

        .img-wrap {
            align-items: center;
            display: flex;
            height: 90px !important;
            justify-content: center;
            text-align: center;
            width: 90px !important;
        }
        .img-wrap img { 
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        
        .info { 
        display: flex; 
        flex-direction: 
        column; gap: 0px; }
        .wrapper *{
            box-sizing: border-box;
        }
        .title { 
          display: block;
          font-size: 15px;
          font-weight: 600;
          margin-bottom: 5px;
          margin-top: 0;
          overflow: hidden !important;
          text-overflow: ellipsis;
          white-space: nowrap;
          width: 100%;
        }
        
        .price { 
          font-size: 14px;
          font-weight: 500;
          line-height: 1;
          margin-bottom: 5px;
        }
        
        .stars { 
          color: #000; 
          font-size: 0.85rem; 
          margin-bottom: 10px;
          display: flex;
          align-items: center;
          gap: 5px;
        }

        .add-btn {
          background: #000; 
          color: #fff; 
          border: none;
          padding: 0.5rem; 
          cursor: pointer; 
          font-weight: bold;
          text-transform: uppercase;
          font-size: 0.9rem;
          width: 100%;
          transition: background 0.2s;
          font-family: inherit;
        }
        .add-btn:hover { background: #333; }

        .nav-btn {
          position: absolute; 
          top: 50%; 
          transform: translateY(-50%);
          background: none; 
          border: none; 
          cursor: pointer;
          z-index: 10;           
          height: 100%;
          padding: 0px;
          width: 20px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        button.nav-btn.next {
            right: -15px!important;
        }

        button.nav-btn.prev {
            left: -15px!important;
        }
        .nav-btn svg {
          width: 20px;
          height: 20px;
          stroke: #000;
          stroke-width: 2px;
          fill: none;
        }
      </style>

      <div class="section-title">You'll love these</div>

      <div class="wrapper">
        <button class="nav-btn prev" aria-label="Previous">
          <svg viewBox="0 0 24 24"><path d="M15 18l-6-6 6-6"/></svg>
        </button>
        <button class="nav-btn next" aria-label="Next">
          <svg viewBox="0 0 24 24"><path d="M9 18l6-6-6-6"/></svg>
        </button>
        
        <div class="container-bg">
          <div class="slider-track">
            ${this.products.map(p => {
              // 1. Find the first variant that is actually available
              const availableVariant = p.variants.find(v => v.available);
              
              // 2. Fallback to the first variant if none are available (so the ID isn't null)
              const variantId = availableVariant ? availableVariant.id : p.variants[0].id;
              
              // 3. Determine button text and disabled state
              const btnText = availableVariant ? 'Add' : 'Sold Out';
              const disabledAttr = availableVariant ? '' : 'disabled';

              return `
                <div class="product-card">
                  <div class="img-wrap">
                    <img src="${p.featured_image}" alt="${p.title}">
                  </div>
                  <div class="info">
                    <div class="title">${p.title}</div>
                    <div class="price">£${(p.price / 100).toFixed(0)}</div>
                    <button class="add-btn" data-id="${variantId}" ${disabledAttr}>${btnText}</button>
                  </div>
                </div>
              `;
            }).join('')}
          </div>
        </div>
      </div>
    `;

    this.shadowRoot.querySelector('.prev').onclick = () => this.scrollSlider(-1);
    this.shadowRoot.querySelector('.next').onclick = () => this.scrollSlider(1);
    this.shadowRoot.querySelectorAll('.add-btn').forEach(btn => {
      btn.onclick = () => this.addToCart(btn.dataset.id);
    });
  }
}

customElements.define('recommendation-slider', RecommendationSlider);



class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  async handleClick() {
    const key = this.dataset.key;

    if (!key) return;

     // Prevent multiple clicks
    if (this.classList.contains('is-removing')) return;

    // Add loading/removing class
    this.classList.add('is-removing');

    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: key,
          quantity: 0
        })
      });

      const cart = await response.json();

      
      new theme.CartDrawer();

    } catch (error) {      
      new theme.CartDrawer();
    }
  }
}

customElements.define('cart-remove-button', CartRemoveButton);



class DeliveryBanner extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: 'open' });
  }

  // Monitor the 'eligible' attribute for changes
  static get observedAttributes() {
    return ['eligible'];
  }

  attributeChangedCallback() {
    this.render();
  }

  connectedCallback() {
    this.render();
  }

  render() {
    const isEligible = this.hasAttribute('eligible');
    
    this.shadowRoot.innerHTML = `
      <style>
        :host {
          display: block;
          font-family: system-ui, -apple-system, sans-serif;
          margin-bottom: 1rem;
        }
        .container {
          padding: 1rem;
          border-radius: 8px;
          text-align: center;
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
          font-weight: 600;
          border: 2px solid transparent;
        }
        /* State: Pending */
        .pending {
          background: #f8f9fa;
          color: #6c757d;
          border: 2px dashed #dee2e6;
        }
        /* State: Eligible */
        .eligible {
          background: rebeccapurple;
          color: white;
          box-shadow: 0 4px 15px rgba(102, 51, 153, 0.3);
          transform: translateY(-2px);
        }
        .icon {
          margin-right: 8px;
        }
      </style>
      ${isEligible 
          ? `
          <div class="container ${isEligible ? 'eligible' : 'pending'}">
            <span class="icon">${isEligible ? '' : ''}</span>
            ${isEligible 
              ? 'You are now eligible for free next day delivery' 
              : ''}
          </div>
          `:''
      }
      
    `;
  }
}

// Define the new element
customElements.define('delivery-banner', DeliveryBanner);